import { useLanguage } from "@/i18n/LanguageContext";

export default function StatsSection() {
  const { t } = useLanguage();

  const stats = [
    { value: "20", label: t("reviews.filterAll"), color: "text-primary" },
    { value: "6", label: t("nav.services"), color: "text-secondary" },
    { value: "12", label: t("home.stat3Label"), color: "text-primary" },
    { value: "$89", label: t("sliding.stat1Label"), color: "text-accent" },
  ];

  return (
    <div className="bg-[#fefce8]">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <div className={`text-4xl md:text-5xl font-black ${s.color} mb-2`}>
                {s.value}
              </div>
              <div className="text-sm font-medium text-secondary">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}